import script from "./AccountRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountRegister.vue?vue&type=script&setup=true&lang=js"

import "./AccountRegister.vue?vue&type=style&index=0&id=045e7862&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-045e7862"]])

export default __exports__